import React from 'react';
import sIcon1 from '../../images/icons/gradu.svg'
import sIcon2 from '../../images/icons/work.svg'
import sIcon3 from '../../images/icons/global.svg'

const Policy = [
    {
        title: 'Strong Alumni Network',
        subTitle: 'Connect with Kodo graduates who can offer support, mentorship, and networking opportunities in AI/ML careers..',
        icon: sIcon1,
    },
    {
        title: 'State-of-the-Art Facilities',
        subTitle: 'Learn in a modern and well-equipped blended environment with access to the latest AI/ML technology and resources.',
        icon: sIcon2,
    },
    {
        title: 'Global Exposure',
        subTitle: 'Collaborate with international teams and gain valuable cross-cultural experience in Data Science projects.',
        icon: sIcon3,
    },


]


const PolicySection = (props) => {

    return (
        <section className="policy_section pt-5" style={{ backgroundColor : '#EBE5FF' }}>
            <div className="container">
                <div className="row mt-5">
                    {Policy.map((policy, pitem) => (
                        <div className="col-md-6 col-lg-4" key={pitem}>
                            <div className="iconbox_block layout_icon_left">
                                <div className="me-3">
                                    <img src={policy.icon}  alt="Dollar SVG Icon" style={{width:'150px'}}/>
                                </div>
                                <div className="iconbox_content">
                                    <h3 className="iconbox_title">{policy.title}</h3>
                                    <p className="mb-0">
                                        {policy.subTitle}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PolicySection;